<template>
  <v-card
    v-bind:class="{ archived: question.archived, hidden: (!viewArchived && question.archived), handle: true }"
    style="cursor:pointer;"
    @mouseover="hovering = true"
    @mouseleave="hovering = false"
    flat
  >
    <div 
      v-if="hovering || viewIdentifiers || activePartId === partId"
      style="position: absolute; right: 0; top: 0; z-index: 999; background: rgba(0,0,0,0.05); padding: 5px; border-bottom-left-radius: 5px; border-top-right-radius: 5px;"
    >
      <span
        v-if="viewIdentifiers"
        style="padding-right:10px;font-family:monospace;font-size:10px"
      >
        Q-{{question.id}} F-{{fieldType.id}} QCLID-{{ question.clid }} FCLID-{{ fieldType.clid }}
      </span>
      <v-chip 
        outline
        color="grey"
        small
        v-if="conditional_part"  
      >
        Conditional
      </v-chip>
      <v-chip 
        outline
        color="grey"
        small
        v-if="question.read_only"  
      >
        Read Only
      </v-chip>
      <v-chip 
        outline
        color="grey"
        small
        v-if="question.web_only"  
      >
        Web Only
      </v-chip>
      <v-chip 
        outline
        color="grey"
        small
        v-if="question.pdf_only"  
      >
        PDF Only
      </v-chip>
      <v-chip 
        outline
        color="grey"
        small
        v-if="question.web_collapsible"  
      >
        Collapsible
      </v-chip>
      <v-chip
        label
        color="blue"
        text-color="white"
        style="text-transform:capitalize; margin-right: 5px;"
        small
      >
        <v-icon v-if="question.is_list" left small>list</v-icon>
        {{ fieldTypePrint }}
      </v-chip>
      <ArchiveButton
        style="display: inline-block; vertical-align: middle; margin-top: -3px;"
        :archived="question.archived"
        @restore="restore()"
        @archive="archive()"
      />
    </div>
    <div style="position:relative;">
      <Preloader v-if="loading" />
      <div>
        <strong
          v-if="question.number"
          v-html="question.number + '.'"
        ></strong>
        &nbsp;
        <span
          class="inlineLimiter"
          v-html="question.text">
        </span>
        <v-icon
          v-if="fieldType.required || checkSubfieldRequired"
          color="red"
          size="18"
          style="vertical-align:middle;padding-left: 10px;"
        >
          mdi-asterisk
        </v-icon>
      </div>
      <div style="margin-top: 10px; pointer-events: none;">
        <component
          :is="answerComponentName"
          :userFormId="0"
          :question="question"
          :fieldType="fieldType"
          :read-only="true"
        />
      </div>
    </div>
  </v-card>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex'
import Preloader from '@/components/global/Preloader'
import ArchiveButton from './ArchiveButton'
import AnswerField from '@/components/admin/userform/AnswerField'
import AnswerList from '@/components/admin/userform/AnswerList'
import CustomFieldType from '@/components/admin/userform/CustomFieldType'
import api from '@/api'

export default {
  name: 'FormTemplateQuestion',
  props: [ 'partId', 'newPart' ],
  components: {
    Preloader,
    ArchiveButton,
    AnswerField,
    AnswerList,
    CustomFieldType
  },
  data () {
    return {
      loading: true,
      conditional_part: false,
      hovering: false,
      loading_options: false
    }
  },
  computed: {
    ...mapGetters('formtemplate', [
      'partById',
      'fieldTypeById'
    ]),
    ...mapState('formtemplate', [
      'viewArchived',
      'viewIdentifiers',
      'activePartId'
    ]),
    question () {
      return this.partById(this.partId) || this.newPart
    },
    fieldType () {
      let ft = this.fieldTypeById(this.question.fieldtype) || this.tempFt
      if (ft.id && ft.option_list && !ft.options) {
        if (!this.loading_options) {
          this.loading_options = true
          api.formtemplate.optionList.get(ft.option_list).then(data => {
            ft.option_list_object = data
            this.$set(ft, 'options', data.options)
            this.loading_options = false
          })
        }
      }
      return ft
    },
    fieldTypePrint () {
      if (this.fieldType.atomic_type_name) {
        if (this.fieldType.atomic_type_name === "number"){
          return "integer"
        }
        return this.fieldType.atomic_type_name
      }
      if (this.question.is_list) {
        return 'list'
      } else {
        return 'custom'
      }
    }, 
    answerComponentName () {
      if (this.question.is_list) {
        return 'AnswerList'
      } else if (this.fieldType.atomic_type === null || this.fieldType.atomic_type === 'custom') {
        return 'CustomFieldType'
      } else {
        return 'AnswerField'
      }
    },
    checkSubfieldRequired () {
      var check = this.fieldType.subfieldtypes.filter((subfield) => {
        if (subfield.required)
          return subfield
      })
      if (check.length > 0)
        return true
      return false
    }
  },
  created () {
    this.conditional_part = (this.question.conditional_question_id)
    this.loading = false
  },
  methods: {
    ...mapActions('formtemplate', [
      'saveQuestion'
    ]),
    archive () {
      this.loading = true
      this.question.archived = true
      this.saveQuestion(this.question)
      .then(question => {
        this.$emit('save', question)
        this.loading = false
      })
    },
    restore () {
      this.loading = true
      this.question.archived = false
      this.saveQuestion(this.question)
      .then(question => {
        this.$emit('save', question)
        this.loading = false
      })
    }
  }
}
</script>

<style scoped>
.question-edit-button {
  margin-left: 10px;
}

.inlineLimiter >>> :first-child {
  display:inline;
}

.hidden {
  display: none !important;
}
</style>
